export function formatPrice(price, noPrices = false, originalPrice = null) {
  if (noPrices) {
    if (originalPrice) {
      return originalPrice.toLocaleString('nl-NL', {
        style: 'currency',
        currency: 'EUR'
      });
    }
    return '';
  }
  return price.toLocaleString('nl-NL', {
    style: 'currency',
    currency: 'EUR'
  });
}
